<template>
  <div class="diadin">
    <div class="topbox">
      <div class="title" :class="active == 1 ? 'action' : ''" @click="active = 1">{{ $t('menu.ClaimOrder') }}</div>
      <div class="title" :class="active == 2 ? 'action' : ''" @click="active = 2">{{ $t('menu.LaborHourList') }}</div>

    </div>
    <attachment v-if="active == 1"></attachment>
    <addclaim v-if="active == 2"></addclaim>
  </div>
</template>

<script>

import attachment from "./order";
// import cart from "./hour";
import addclaim from './addclaim.vue'
export default {
  components: {
    attachment,
    addclaim
  },
  data () {
    return {

      active: 1,

    };
  },
  created () {

  },
  methods: {
    handleEdit (index, row) {
      this.$router.push({
        path: "/sellcontent",
        query: {
          vin: row.vin,
          type: index,
        },
      });
    },
    changeActive(e){
      this.active = e
    },
    
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.topbox {
  display: flex;
}

.title {
  width: 200px;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  margin-right: 40px;
  text-align: center;
  cursor: pointer;
}

.action {
  color: #fff;
  background-color: #409eff;

}
</style>